import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { showAlert } from "@utils/Alert";
import { isEDocumentAtvPending } from "@utils/edocumentAtvStatus";

export const ATV_PENDING_CANCEL_MESSAGE =
  "La factura aun no tiene respuesta de Hacienda. Espere a que el documento sea aceptado o rechazado antes de anularlo.";

export const ATV_PENDING_NOTE_MESSAGE =
  "La factura aun no tiene respuesta de Hacienda. Espere a que el documento sea aceptado o rechazado antes de crear la nota de credito.";

type AtvGuardableInvoice = Pick<InvoiceDataType, "id" | "edocument_status_payload">;

/**
 * Estado ATV recien leido de GraphQL. Los listados se sirven de Meili, que tiene lag de
 * indexado: una factura ya aceptada puede seguir apareciendo como pendiente en el hit.
 * Si la relectura falla se conserva el payload que traia la fila.
 */
const readFreshStatusPayload = async (
  invoice: AtvGuardableInvoice
): Promise<string | null | undefined> => {
  try {
    const loaded = await InvoiceApi.get(`${invoice.id}`, {
      selectionSet: ["id", "edocument_status_payload"],
    });
    return loaded?.edocument_status_payload ?? null;
  } catch {
    return invoice.edocument_status_payload;
  }
};

/**
 * Deja continuar solo cuando Hacienda ya resolvio el documento (aceptado o rechazado).
 * Mientras siga pendiente no se puede anular la factura ni emitir notas contra ella,
 * porque quedarian referenciando un comprobante cuyo destino final se desconoce.
 *
 * Sin facturacion electronica activa no aplica ninguna restriccion.
 *
 * @returns true si la accion puede continuar; false tras mostrar el mensaje al usuario.
 */
export const ensureInvoiceAtvAnswered = async (
  invoice: AtvGuardableInvoice,
  einvoiceActive: boolean,
  message: string
): Promise<boolean> => {
  if (!einvoiceActive) {
    return true;
  }

  if (!isEDocumentAtvPending(invoice.edocument_status_payload)) {
    return true;
  }

  if (!invoice.id) {
    showAlert("danger", message);
    return false;
  }

  const freshPayload = await readFreshStatusPayload(invoice);
  if (!isEDocumentAtvPending(freshPayload)) {
    return true;
  }

  showAlert("danger", message);
  return false;
};
